var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_5118)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6632 11.3307C14.6632 11.6842 14.5227 12.0232 14.2728 12.2732C14.0228 12.5232 13.6837 12.6637 13.3302 12.6637H4.55091C4.1974 12.6637 3.8584 12.8042 3.60847 13.0542L2.14082 14.5219C2.07464 14.5881 1.99032 14.6331 1.89853 14.6514C1.80675 14.6696 1.71161 14.6603 1.62514 14.6245C1.53868 14.5886 1.46478 14.528 1.41278 14.4502C1.36078 14.3724 1.33302 14.2809 1.33301 14.1873V3.33254C1.33301 2.97901 1.47345 2.63995 1.72344 2.38996C1.97343 2.13997 2.31249 1.99953 2.66603 1.99953H13.3302C13.6837 1.99953 14.0228 2.13997 14.2728 2.38996C14.5227 2.63995 14.6632 2.97901 14.6632 3.33254V11.3307Z",
    stroke: "currentColor",
    strokeWidth: 1.33302,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_5118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9962,
    height: 15.9962,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d4248ce48b9f563f1f0d7f66ec962a65.svg";
export { ForwardRef as ReactComponent };